import { Outlet } from '@tanstack/react-router';
import { Resizable } from 're-resizable';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

import { merge } from '@/components';

export type NavigationBarProps = DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> & {
  initialWidth?: number;
  enableResizing?: boolean;
};

export const NavigationBar = ({ initialWidth, enableResizing, className, children, ...rest }: NavigationBarProps) => {
  /* prettier-ignore */
  const styles = [
    'border-r',
    'flex',
    'flex-col',
    'h-full',
  ];
  /* prettier-ignore */
  const lightStyles = [
    'border-gray-200',
    'bg-white',
  ];
  return (
    <div className="flex h-full min-h-0">
      <Resizable defaultSize={{ width: initialWidth ?? 250 }} enable={{ right: enableResizing ?? true }}>
        <nav className={merge(styles, lightStyles, className)} {...rest}>
          {children}
        </nav>
      </Resizable>
      <Outlet />
    </div>
  );
};
